import React, { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from '@/app/core/auth/application/hooks/useAuth';
import { useApp } from '@/platform/app/useApp';
import { landingFor, useViewer } from '@/platform/auth/audience';

interface PublicRouteProps {
  children: ReactNode;
}

/** An already-authenticated visitor is sent to the landing of their audience (customer or staff). */
export const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const app = useApp();
  const viewer = useViewer();

  return !isAuthenticated ? <>{children}</> : <Navigate to={landingFor(app, viewer)} replace />;
};
